import { useEffect } from 'react';
import HeroSection from './components/HeroSection';
import CategorySection from './components/CategorySection';
import PromotionSection from './components/PromotionSection';
import ArticleSection from './components/ArticleSection';
import FAQSection from './components/FAQSection';
import { siteInfo } from '@/mocks/data';

export default function Home() {
  useEffect(() => {
    document.title = `${siteInfo.name}·官方正版平台 | 安全畅玩赢无止境`;
  }, []);

  const jsonLd = {
    '@context': 'https://schema.org',
    '@type': 'WebPage',
    name: `${siteInfo.name} - 首页`,
    description: siteInfo.description,
    url: siteInfo.url,
    isPartOf: {
      '@type': 'WebSite',
      name: siteInfo.name,
      url: siteInfo.url,
    },
  };

  return (
    <>
      <script type="application/ld+json">{JSON.stringify(jsonLd)}</script>
      <main>
        <HeroSection />
        <CategorySection />
        <PromotionSection />
        <ArticleSection />
        <FAQSection />
      </main>
    </>
  );
}